import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { LanguageService } from './language.service';


@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {

  language: string;
  
  @Output() containerIsHovered: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private route: ActivatedRoute, private translateService: TranslateService, private languageService: LanguageService) {
  }

  ngOnInit() {

    this.language = this.languageService.defineLanguage(localStorage.getItem('lang'));
    this.translateService.addLangs(['es', 'us', 'br']);
    this.translateService.use(this.language);
  }

}
